import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

interface EmailServiceLoadingSkeletonProps {
  numPreviewGroups?: number;
}

export const EmailServiceLoadingSkeleton: FC<EmailServiceLoadingSkeletonProps> = ({ numPreviewGroups = 1 }) => {
  return (
    <>
      <Skeleton className="mb-3" count={1} height={40} inline />
      {[...Array(numPreviewGroups).keys()].map(key => (
        <div key={key} style={{ lineHeight: 1 }}>
          <Skeleton className="mb-2" count={0.1} height={20} borderRadius={0} inline />
          <Skeleton className="mb-3" count={1} height={40} inline />
        </div>
      ))}
      <div style={{ lineHeight: 1 }}>
        <Skeleton className="mb-2" count={0.1} height={20} borderRadius={0} inline />
        <Skeleton className="mb-3" count={1} height={90} inline />
      </div>
    </>
  );
};
